import { RemoteUpdateNameApiKey } from 'data/usecases/api-keys';
import { makeApiUrlApiKeys } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdateNameApiKey = (): RemoteUpdateNameApiKey => {
  return new RemoteUpdateNameApiKey(makeApiUrlApiKeys(), makeAxiosHttpClient());
};
